import { toaster } from "../Components/ui/toaster";


const useToaster = () => {
  const showSuccessToast = (description?: string) => {
    toaster.success({
      title: "Success!",
      description: description || "",
      type: "success",
      duration: 5000,
      closable: true,
    
    });
  };

  const showErrorToast = (description?: string) => {
    toaster.error({
      title: "Error!",
      description: description || "",
      type: "error",
      duration: 5000,
      closable: true,
    });
  };

  const showWarningToast = (description?: string) => {
    toaster.warning({
      title: "Warning!",
      description: description || "",
      type: "warning",
      duration: 5000,
      closable: true,
    });
  };

  const showInfoToast = (description?: string) => {
    toaster.info({
      title: "Info!",
      description: description || "",
      type: "info",
      duration: 5000,
      closable: true,
    });
  };

  return { showSuccessToast, showErrorToast, showWarningToast, showInfoToast };
};

export default useToaster;
